import { render, staticRenderFns } from "./StatusPillButton.vue?vue&type=template&id=24ebffc4&scoped=true"
import script from "./StatusPillButton.vue?vue&type=script&lang=js"
export * from "./StatusPillButton.vue?vue&type=script&lang=js"
import style0 from "./StatusPillButton.vue?vue&type=style&index=0&id=24ebffc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ebffc4",
  null
  
)

export default component.exports